import {
  DefualtAPIMessageResponse,
  LoginResponse,
  RegisterResponse,
  SocialLoginInitiateAPIResponse,
} from "types/api";

import { axiosBaseQuery } from "@picovico/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { changePasswordValues } from "components/Forms/ChangePasswordForm";
import { forgotPasswordValues } from "components/Forms/ForgotPasswordForm";
import type { loginValues } from "components/Forms/LoginForm";
import { registerValues } from "components/Forms/RegisterForm";
import { resetPasswordValues } from "components/Forms/ResetPasswordForm";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    loginUser: builder.mutation<LoginResponse, loginValues>({
      query: (data) => ({
        name: "login_user",
        method: "POST",
        data,
      }),
    }),
    logoutUser: builder.mutation<DefualtAPIMessageResponse, void>({
      query: () => ({
        name: "logout_user",
        method: "POST",
      }),
    }),
    socialLoginInitiate: builder.query<
      SocialLoginInitiateAPIResponse,
      { idx: string; next?: string; state?: string }
    >({
      query: ({ idx, next, state }) => ({
        name: "social_login_initiate",
        method: "GET",
        idx,
        params: next || state ? { next, state } : undefined,
      }),
    }),
    socialLoginVerify: builder.query<
      LoginResponse,
      { idx: string; params: any }
    >({
      query: ({ idx, params }) => ({
        name: "social_login_verify",
        method: "GET",
        idx,
        params,
      }),
    }),
    forgotPassword: builder.mutation<
      DefualtAPIMessageResponse,
      forgotPasswordValues
    >({
      query: (data) => ({
        name: "forgot_password",
        method: "POST",
        data,
      }),
    }),
    resetPassword: builder.mutation<
      DefualtAPIMessageResponse,
      resetPasswordValues
    >({
      query: (data) => ({
        name: "reset_password",
        method: "POST",
        data,
      }),
    }),
    registerUser: builder.mutation<RegisterResponse, registerValues>({
      query: (data) => ({
        name: "register_user",
        method: "POST",
        data,
      }),
    }),
    changePassword: builder.mutation<
      DefualtAPIMessageResponse,
      changePasswordValues
    >({
      query: (data) => ({
        name: "change_password",
        method: "POST",
        data,
      }),
    }),
  }),
});

export const {
  useLoginUserMutation,
  useLogoutUserMutation,
  useSocialLoginInitiateQuery,
  useLazySocialLoginInitiateQuery,
  useSocialLoginVerifyQuery,
  useLazySocialLoginVerifyQuery,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useRegisterUserMutation,
  useChangePasswordMutation,
} = authApi;
